import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53838074"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sheet_header" }
const _hoisted_2 = { class: "sheet_header_title1" }
const _hoisted_3 = { class: "sheet_header_title2" }
const _hoisted_4 = { class: "sheet_content" }
const _hoisted_5 = { class: "sheet_content_cell3" }

import { computed } from 'vue';
import { TActionSheet, TCell } from '@tencent/web-vbui';


export default /*#__PURE__*/_defineComponent({
  __name: 'applyExtra',
  props: {
    menuActionSheet: { type: Boolean }
  },
  emits: ["update:menuActionSheet", "teslaCheckTypeClick", "closeSheet"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:menuActionSheet', show: boolean): void;
  (event: 'teslaCheckTypeClick', type: string): void;
  (event: 'closeSheet'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { menuActionSheet: boolean }





// const comShowApplyTips = computed({
//   get: () => props.showApplyTips,
//   set: (val) => emits('update:showApplyTips', val),
// });

const comMenuActionSheet = computed({
  get: () => props.menuActionSheet,
  set: (val) => emits('update:menuActionSheet', val),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TActionSheet), {
    "is-need-close": true,
    modelValue: _unref(comMenuActionSheet),
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(comMenuActionSheet) ? (comMenuActionSheet).value = $event : null)),
    onClose: _cache[4] || (_cache[4] = ($event: any) => (emits('closeSheet')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("text", _hoisted_2, _toDisplayString(_ctx.$t('登记Tesla车主身份')), 1),
        _createElementVNode("text", _hoisted_3, _toDisplayString(_ctx.$t('选择登记信息的方式，获得Tesla专享贷款资格')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(TCell), {
          size: "large",
          "has-top-border": true,
          "has-arrow": true,
          "has-bottom-border": false,
          "left-title": _ctx.$t('使用车辆识别号码登记'),
          "left-label": _ctx.$t('（适用于已有车车主）'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('teslaCheckTypeClick', 'PIN')))
        }, null, 8, ["left-title", "left-label"]),
        _createVNode(_unref(TCell), {
          size: "large",
          "has-top-border": true,
          "has-arrow": true,
          "has-bottom-border": false,
          "left-title": _ctx.$t('使用订单号登记'),
          "left-label": _ctx.$t('（适用于已预订Tesla的准车主）'),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('teslaCheckTypeClick', 'RN')))
        }, null, 8, ["left-title", "left-label"]),
        _createVNode(_unref(TCell), {
          size: "medium",
          "has-top-border": true,
          "has-arrow": true,
          "has-bottom-border": false,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('teslaCheckTypeClick', 'TESLAFAQ')))
        }, {
          leftTitle: _withCtx(() => [
            _createElementVNode("text", _hoisted_5, _toDisplayString(_ctx.$t('如何获取Tesla专享贷款资格')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})